import * as React from "react";
import { Routes, Route } from "react-router-dom";
import AdminSites from "./AdminSites";
import AdminSite from "./AdminSite";

const AdminSitesRouter: React.FC = () => {
  return (
    <Routes>
      <Route index element={<AdminSites />} />
      <Route path=":siteId/*" element={<AdminSite />} />
    </Routes>
  );
};

export default AdminSitesRouter;
